'use strict';
import listActions  from '../actions/listActions';
import {fromJS}     from 'immutable';

const INITIAL_STATE = fromJS({
  isLoading : false,
  isSent    : false,
});

const emailReducer = (state, action) => {
  if (!state){
    state = INITIAL_STATE;
  }

  if (!action.type) {
    return state;
  }

  switch (action.type) {

    case listActions.SEND_EMAIL_START : {
      return state
        .set('isLoading', true)
        .set('isSent', false);
    }

    case listActions.SEND_EMAIL_SUCCESS : {
      return state
        .set('isLoading', false)
        .set('isSent', true);
    }

    case listActions.SEND_EMAIL_FAIL : {
      return state.set('isLoading', false);
    }

    default : {
      return state;
    }

  }
};

export default emailReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/emailReducer.js